
export const enviroments = {
     URL_BASE: 'https://backend.shamaimspa.com/public/api/v1',
     URL_BASE_IMAGES: 'https://backend.shamaimspa.com/public/api/v1/files'
}

